<template>
  <!-- User is logged in -->
  <template v-if="loggedIn">
    <div v-if="desktopUser" class="flex lg:px-[5px]">
      <div class="topbar__login-button flex" @mouseover="toggleAccount(1)" @mouseleave="toggleAccount(0)">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="Group_10481" data-name="Group 10481" transform="translate(-4957 -13508)">
            <rect id="Rectangle_647" data-name="Rectangle 647" width="24" height="24" transform="translate(4957 13508)" fill="none"></rect>
            <path id="Icon" d="M8,0A3.943,3.943,0,0,0,4,4.268,7.117,7.117,0,0,0,6,9v1.669c-.667,2-6,.667-6,5.333H16c0-4.667-5.333-3.333-6-5.333V9a7.117,7.117,0,0,0,2-4.729A3.943,3.943,0,0,0,8,0Z" transform="translate(4961 13512)" stroke="rgba(0,0,0,0.1)" strokewidth="1"></path>
          </g>
        </svg>
        <div class="items-center flex">
          <div class="topbar-drop-menu__container" :class="openProfile==1 ? 'header__account--show' : ''" style="left: 0px;">
            <div class="first-level-link" style="font-weight: normal; background-color: rgb(255, 255, 255);">
              <button class="dropdown__link-text " style="pointer-events: auto;">
                <div class="dropdown__link-menu_label">
                  <div class="topbar__greeting-container">{{ $t('account.hello') }}, {{ fullName }}</div>
                </div>
              </button>
            </div>
            <div class="first-level-link" style="font-weight: normal; background-color: rgb(255, 255, 255);">
              <a :href="overviewLink">
                <button class="dropdown__link-text link" data-ga-group="header" data-ga-element="button" data-ga-index="1" style="pointer-events: auto;">
                  <div class="dropdown__link-menu_label">{{ $t('account.overview') }}</div>
                </button>
              </a>
            </div>
            <div class="first-level-link" style="font-weight: normal; background-color: rgb(255, 255, 255);">
              <a :href="profileLink">
                <button class="dropdown__link-text link" data-ga-group="header" data-ga-element="button" data-ga-index="2" style="pointer-events: auto;">
                  <div class="dropdown__link-menu_label">{{ $t('account.profile') }}</div>
                </button>
              </a>
            </div>
            <div class="first-level-link" style="font-weight: normal; background-color: rgb(255, 255, 255);">
              <a :href="logoutLink" @click.prevent="logoutAction">
                <button class="dropdown__link-text link" data-ga-group="header" data-ga-element="button" data-ga-index="5" style="pointer-events: auto;">
                  <div class="dropdown__link-menu_label">{{ $t('account.logout') }}</div>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex lg:px-[5px]" data-ga-group="header" data-ga-element="login_button">
      <div class="login flex items-center lg:hidden" @click="mobileToggleAccount">
        <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 73 73" class="mobile-dropdown-menu__profile-icon mobile-dropdown-menu__first-level-profile-icon">
          <title>Profile</title>
          <g id="Group_10547" data-name="Group 10547" transform="translate(-542 -461)">
            <rect id="Rectangle_744" data-name="Rectangle 744" width="73" height="73" transform="translate(542 461)" fill="none"></rect>
            <rect id="Rectangle_745" data-name="Rectangle 745" width="33" height="33" transform="translate(562 481)" fill="none"></rect>
            <path id="Icon" d="M16.5,0C11.6,0,8.25,3.6,8.25,8.8a14.679,14.679,0,0,0,4.125,9.754V22C11,26.125,0,23.375,0,33H33c0-9.625-11-6.875-12.375-11V18.557A14.679,14.679,0,0,0,24.75,8.8C24.75,3.6,21.4,0,16.5,0Z" transform="translate(562 481)"></path>
          </g>
        </svg>
        <div class="topbar__greeting-container">{{ $t('account.hello') }}, {{ fullName }}</div>
      </div>
      <div class="mobile-dropdown-menu__profile-menu-container" v-if="mobileAccountOpen">
        <div class="mobile-dropdown-menu__profile-menu-content">
          <div class="mobile-dropdown-menu__profile-menu-title-content">
            <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 73 73" class="mobile-dropdown-menu__profile-icon mobile-dropdown-menu__second-level-profile-icon">
              <title>Profile</title>
              <g id="Group_10547" data-name="Group 10547" transform="translate(-542 -461)">
                <rect id="Rectangle_744" data-name="Rectangle 744" width="73" height="73" transform="translate(542 461)" fill="none"></rect>
                <rect id="Rectangle_745" data-name="Rectangle 745" width="33" height="33" transform="translate(562 481)" fill="none"></rect>
                <path id="Icon" d="M16.5,0C11.6,0,8.25,3.6,8.25,8.8a14.679,14.679,0,0,0,4.125,9.754V22C11,26.125,0,23.375,0,33H33c0-9.625-11-6.875-12.375-11V18.557A14.679,14.679,0,0,0,24.75,8.8C24.75,3.6,21.4,0,16.5,0Z" transform="translate(562 481)"></path>
              </g>
            </svg>
            <h2>{{ $t('account.hello') }}, {{ fullName }}</h2>
            <button @click="mobileToggleAccount" class="mobile-dropdown-menu__close-profile-menu-button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">Close mobile dropdown button<g id="Group_10482" data-name="Group 10482" transform="translate(-4987 -13508)">
                  <rect id="Rectangle_648" data-name="Rectangle 648" width="24" height="24" transform="translate(4987 13508)" fill="none"></rect>
                  <path id="Path_450" data-name="Path 450" d="M3.822,0,7.171,5.8,3.438,11.608H0L4.166,5.719.612,0Z" transform="translate(4995.395 13514.195)"></path>
                </g>
              </svg>
            </button>
          </div>
          <a :href="overviewLink">
            <h2 class="mobile-dropdown-menu__profile-menu-row">{{ $t('account.overview') }}</h2>
          </a>
          <a :href="profileLink">
            <h2 class="mobile-dropdown-menu__profile-menu-row">{{ $t('account.profile') }}</h2>
          </a>
          <a :href="logoutLink" @click.prevent="logoutAction">
            <h2 class="mobile-dropdown-menu__profile-menu-row">{{ $t('account.logout') }}</h2>
          </a>
        </div>
      </div>
    </div>
  </template>

  <!-- User is not logged in -->
  <template v-else>
    <a :href="loginUrl">
      <div class="login flex items-center" :class="desktopUser ? 'lg:px-[5px]' : 'lg:hidden'">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="Group_10481" data-name="Group 10481" transform="translate(-4957 -13508)">
            <rect id="Rectangle_647" data-name="Rectangle 647" width="24" height="24" transform="translate(4957 13508)" fill="none"></rect>
            <path id="Icon" d="M8,0A3.943,3.943,0,0,0,4,4.268,7.117,7.117,0,0,0,6,9v1.669c-.667,2-6,.667-6,5.333H16c0-4.667-5.333-3.333-6-5.333V9a7.117,7.117,0,0,0,2-4.729A3.943,3.943,0,0,0,8,0Z" transform="translate(4961 13512)" stroke="rgba(0,0,0,0.1)" strokewidth="1"></path>
          </g>
        </svg>
        {{ $t('account.sign_in') }}
      </div>
    </a>
  </template>
</template>

<script>

import { mapState, mapActions } from 'vuex'

export default {
  name: 'header-account-new',
  data() {
    return {
      mobileAccountOpen: false,
      openProfile: 0,
    };
  },
  props: {
    desktopUser: {
      type: Boolean,
      required: true
    }
  },
  async created() {
    await this.retrieveUserDetails();
  },
  methods: {
    toggleAccount(open) {
      this.openProfile = open;
    },
    mobileToggleAccount() {
      this.mobileAccountOpen = !this.mobileAccountOpen;
    },
    async logoutAction() {
      this.updateLoading(true);
      await this.destroyCartInstance();
      window.location.href = process.env.VUE_APP_WK_CRM_URL + '/oauth/logout?redirect=' + window.location.href;
    },
    ...mapActions(['retrieveUserDetails', 'destroyCartInstance', 'updateLoading'])
  },
  computed: {
    loggedIn() {
      return this.user.userLoggedIn;
    },
    fullName() {
      return this.user.userDetails.firstName + ' ' + this.user.userDetails.lastName
    },
    customerPortal() {
      return process.env.VUE_APP_WK_ACCOUNT_BASE_URL
    },
    overviewLink() {
      return `${this.customerPortal}?language=${this.getCRMLocale}`
    },
    eventsLink() {
      return `${this.customerPortal}/my-events?language=${this.getCRMLocale}`
    },
    profileLink() {
      return `${this.customerPortal}?language=${this.getCRMLocale}`
    },
    shoppingCartLink() {
      return `/cart`
    },
    registerUrl() {
      return `${process.env.VUE_APP_WK_CRM_URL}/oauth/register?redirect=${window.location.href}&language=${this.$i18n.locale}`;
    },
    loginUrl() {
      return `${process.env.VUE_APP_WK_CRM_URL}/oauth/check?redirect=${window.location.href}&language=${this.$i18n.locale}`;
    },
    logoutLink() {
      // logoutAction should be used; but we should supply a URL
      return process.env.VUE_APP_WK_CRM_URL + '/oauth/logout?redirect=' + window.location.href;
    },
    getCRMLocale() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'en_HK';
        case 'tc':
          return 'zh_HK';
        case 'sc':
          return 'zh_CN';
        default:
          return 'en_HK';
      }
    },
    ...mapState(['user'])
  }
}
</script>

<style></style>